export function radioButton() {
  $(".radio-btn input[name=radio]").on("change", function () {
    if ($(this).val() == 'val1') {
      $(this).parent().addClass('radio1-active');
      $('#data-radio1').parent().addClass('hide')
    }
    else {
      $(this).parent().removeClass('radio1-active');
      $('#data-radio1').parent().removeClass('hide')
    }
  });
  $(".radio-btn input[name=radio]").on("change", function () {
    if ($(this).val() == 'val2') {
      // $('#data-radio1').find('.note').html('11111<span>kWh</span>')
      // $('#data-radio2').find('.note').html('22222<span>kWh</span>')
      $(this).parent().addClass('radio2-active');
    }
    else {
      // $('#data-radio1').find('.note').html('99999<span>kWh</span>')
      // $('#data-radio2').find('.note').html('99999<span>kWh</span>')
      $(this).parent().removeClass('radio2-active');
    }
  });
  $(".radio-btn input[name=radio]").on("change", function () {
    if ($(this).val() == 'val3') {
      $(this).parent().addClass('radio3-active');
      // $('#data-radio1').find('.note').html('99999<span>kWh</span>')
      // $('#data-radio2').find('.note').html('99999<span>kWh</span>')
    }
    else {
      $(this).parent().removeClass('radio3-active');
      // $('#data-radio1').find('.note').html('11111<span>kWh</span>')
      // $('#data-radio2').find('.note').html('22222<span>kWh</span>')
    }
  });
  $(".radio-btn2 input[name=radio2]").on("change", function () {
    if ($(this).val() == 'val4') {
      // $('#data-radio4').find('.note').html('44444<span>kg</span>')
      // $('#data-radio5').find('.note').html('55555<span>kg</span>')
      $(this).parent().addClass('radio1-active2');
    }
    else {
      // $('#data-radio4').find('.note').html('99999<span>kg</span>')
      // $('#data-radio5').find('.note').html('99999<span>kg</span>')
      $(this).parent().removeClass('radio1-active2');
    }
  });
}


